<template>
  <a-button type="link" @click="create">
    {{ title }}
  </a-button>
  <a-modal :open="isShow" :title="title" @ok="ok" @cancel="cancel" width="60%">
    <a-form
      ref="formRef"
      :model="formData"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <form-input
        label="系统code"
        name="parentName"
        disabled
        v-model:value="systemCode"
      ></form-input>
      <form-input
        label="按钮名称"
        name="menuName"
        v-model:value="formData.menuName"
      ></form-input>
      <form-select
        label="类型"
        name="menuType"
        v-model:value="formData.menuType"
      >
        <a-select-option
          :value="item.id"
          :key="item.id"
          v-for="item in typeList"
        >
          {{ item.name }}
        </a-select-option>
      </form-select>
      <form-input
        placeholder="只能输入英文+数字"
        label="按钮CODE"
        name="menuCode"
        v-model:value="formData.menuCode"
      ></form-input>
      <form-input
        label="按钮接口PATH"
        name="menuPath"
        v-model:value="formData.menuPath"
        placeholder="/123/456"
      ></form-input>
    </a-form>
  </a-modal>
</template>
<script>
import { message } from 'ant-design-vue'
import { inject, toRefs, reactive, ref } from 'vue'
import { mergeObject } from 'utils/index.js'
import { menu_operate_post } from 'server/modules/351.js'
export default {
  setup(props, { attrs }) {
    const state = inject('state')
    const menusState = inject('menusState')
    const text = attrs.text
    const formRef = ref()
    const alertState = reactive({
      ...attrs,
      isShow: false,
      typeList: [
        {
          name: '按钮',
          id: 3
        }
      ],
      rules: {
        menuName: [
          {
            required: true,
            message: '必填',
            trigger: 'blur'
          }
        ],
        menuType: [
          { required: true, message: '必填', trigger: 'blur', type: 'number' }
        ],
        menuCode: [
          {
            required: true,
            message: '必填',
            trigger: 'blur',
            type: 'string'
          },
          { min: 1, message: '最大长度不能超过15位', trigger: 'blur' },
          {
            pattern: '^[^\u4e00-\u9fa5]+$',
            message: '必须由非中文组成',
            trigger: 'blur'
          }
        ]
      },
      cancel() {
        const { setEmpty } = menusState
        alertState.isShow = false
        setEmpty()
      },
      create() {
        const { setEmpty } = menusState
        setEmpty()
        alertState.isShow = true
        if (alertState.title === '修改') {
          menusState.formData = mergeObject(menusState.formData, text)
        } else {
          menusState.formData.parentId = text.id
          menusState.formData.menuType = 3
        }
      },
      ok: async () => {
        formRef.value
          .validate()
          .then(() => {
            alertState.add()
          })
          .catch(error => {
            console.log('error', error)
          })
      },
      // 新增地址
      add: async () => {
        const { formData } = menusState

        const { success, retInfo } = await menu_operate_post(
          formData
        ).catch(() => {})
        if (success) {
          alertState.cancel()
          menusState.queryMenuList()
          // state.changePage(1)
          message.info(retInfo)
        } else {
          message.error(retInfo)
        }
      },
      change: info => {
        const { formData } = menusState
        formData.menuIcon = info.fileList[0].response.data
      }
    })

    return {
      formRef,
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      ...toRefs(alertState),
      ...toRefs(state),
      ...toRefs(menusState)
    }
  }
}
</script>
